function alignSecondaryMenu() {
  // Solo su desktop
  if (window.innerWidth < 990) {
    const logo = document.querySelector('.header__heading-link');
    if (logo) {
      logo.style.position = '';
      logo.style.top = '';
    }
    return;
  }

  const primaryNav = document.querySelector('.header__inline-menu__primary');
  const secondaryNav = document.querySelector('.header__menuSecondary');
  const logo = document.querySelector('.header__heading-link');
  
  if (!primaryNav || !secondaryNav || !logo) return;

  const offset = primaryNav.getBoundingClientRect().left;
  secondaryNav.style.paddingInlineStart = offset + 'px';

  const primaryHeight = primaryNav.getBoundingClientRect().height;
  const secondaryHeight = secondaryNav.getBoundingClientRect().height;
  const totalMenuHeight = primaryHeight + secondaryHeight;
  const logoHeight = logo.getBoundingClientRect().height;
  const topOffset = (totalMenuHeight - logoHeight) / 2;
  
  logo.style.position = 'relative';
  logo.style.top = topOffset + 'px';
}

alignSecondaryMenu();
window.addEventListener('resize', alignSecondaryMenu);